<template>
  <a-drawer :visible="visible"
            :title="title"
            width="60%"
            destroyOnClose
            @close="onClose">
    <div>
      <From ref="formRef"
            layoutType="grid"
            :isErrorMessage="false"
            :optionList="formRows"
            :formRules="formRules"
            :defaultModel="defaultModel">
      </From>
    </div>
    <div class="footer-but">
      <a-button style="marginRight: 8px"
                @click="onClose">
        取消
      </a-button>
      <a-button class="first-but"
                type="primary"
                @click="handleOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import {is_cloneDeep} from '@/utils/cloneDeep.js'
import { addDept, updateDept, getDeptDetail } from '@/api/back.js'
import { formRows, formRules } from './modal.js'
import From from '@/views/Back/components/formTable/form.vue'
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    }
  },
  components: { From },
  data() {
    return {
      title: '新增',
      formRows: [],
      formRules: {}, // 表单校验规则配置
      defaultModel: {} // 表单的默认值
    }
  },
  //模拟动态添加数据
  watch: {
    visible: {
      handler(n) {
        if (n) {
          this.formRules = is_cloneDeep(formRules)
          this.formRows = is_cloneDeep(formRows)
          this.formRows.forEach((item, i) => {
            if (item.prop === 'parentId') {
              this.$set(this.formRows[i], 'list', this.treeData)
            }
            // if(this.isEdit && item.prop === 'num') {
            //     this.$set(this.formRows[i], 'disabled', true)
            // } else if (!this.isEdit && item.prop === 'num') {
            //     this.$set(this.formRows[i], 'disabled', false)
            // }
          })
          if (this.row && !this.isEdit) {
            // if (!this.row.parentId) {
            //   this.defaultModel = {
            //     parentId: this.row.id
            //   }
            // } else {
            //   this.defaultModel = {
            //     parentId: this.row.id
            //   }
            this.defaultModel = {
              parentId: this.row.id
             }
            
          }
          if (this.isEdit) {
            this.$set(this.formRules,'parentId',[
              { required: false, message: '请选择上级组织', trigger: 'change'}
            ])
            this.title = '编辑'
            this.getData()
          }
        }
      }
    }
  },
  methods: {
    async handleOk() {
      const v1 = this.$refs.formRef.validatedForm()
      const refD = this.$refs.formRef.formModel
      if (!v1) {
        return false
      }
      console.log('refD', refD)
      if (!refD.parentId) {
        refD.parentId = ''
      }
      const res = this.isEdit
        ? await updateDept({ ...refD, deptId: this.row.id })
        : await addDept(refD)
      console.log(res)
      if (res.code === 200) {
        this.$message.success(res.msg)
        this.reset()
        this.$emit('ok')
      } else {
        this.$message.error(res.msg)
      }
    },
    onClose() {
      this.reset()
      this.$emit('ok')
    },
    reset() {
      this.title = '新增'
      this.defaultModel = {}
    },
    async getData() {
      const {
        data: { parentId, deptName, leader, orderNum, phone, email }
      } = await getDeptDetail(this.row.id)
      if (this.isEdit && !parentId) {
          this.$set(this.formRows[0], 'disabled', true)
        }
      this.defaultModel = {
        parentId: parentId || '',
        deptName,
        leader,
        orderNum,
        phone,
        email
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>